import useSWR from 'swr';
import { fetchJSON } from '@/lib/api/fetcher';
import type { TraceListResponse, TraceDetail } from '@/lib/api/internalTracing';

interface TraceFilters {
  user_id?: string;
  conversation_id?: string;
  trace_id?: string;
  status?: string;
  route?: string;
  from?: string;
  to?: string;
  limit?: number;
  page?: number;
  include_internal?: boolean;
  min_span_count?: number;
}

function buildQuery(filters: TraceFilters): string {
  const params = new URLSearchParams();
  if (filters.user_id) params.set('user_id', filters.user_id);
  if (filters.conversation_id) params.set('conversation_id', filters.conversation_id);
  if (filters.trace_id) params.set('trace_id', filters.trace_id);
  if (filters.status) params.set('status', filters.status);
  if (filters.route) params.set('route', filters.route);
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.include_internal !== undefined) params.set('include_internal', String(filters.include_internal));
  if (filters.min_span_count !== undefined) params.set('min_span_count', String(filters.min_span_count));
  params.set('limit', String(filters.limit ?? 50));
  params.set('page', String(filters.page ?? 1));
  return params.toString();
}

export function useTraceList(filters: TraceFilters, enabled: boolean) {
  const query = buildQuery(filters);
  return useSWR<TraceListResponse>(
    enabled ? `/internal/ops/traces?${query}` : null,
    fetchJSON,
    {
      refreshInterval: 15_000,
      revalidateOnFocus: false,
      dedupingInterval: 5_000,
    }
  );
}

export function useTraceDetail(traceId: string | null, enabled: boolean) {
  return useSWR<TraceDetail>(
    enabled && traceId ? `/internal/ops/traces/${traceId}` : null,
    fetchJSON,
    {
      revalidateOnFocus: false,
    }
  );
}
